type StickerTextProps = {
  isDg2Project: boolean;
  noProductionPlan: boolean;
  noProductionDomain: boolean;
  isProductionEnvironment: boolean;
};

type UserTypeType = Readonly<{
  HAS_CUSTOM_DOMAINS: string;
  NO_CAPABILITY: string;
  NO_PRODUCTION_PLAN: string;
  NO_PRODUCTION_DOMAIN: string;
  NO_PERMISSION: string;
}>;

const userType: UserTypeType = Object.freeze({
  HAS_CUSTOM_DOMAINS: "hasCustomDomains",
  NO_CAPABILITY: "noCapability",
  NO_PRODUCTION_PLAN: "noProductionPlan",
  NO_PRODUCTION_DOMAIN: "noProductionDomain",
  NO_PERMISSION: "noPermission"
});

export function getStickerText({
  isDg2Project,
  noProductionPlan,
  noProductionDomain,
  isProductionEnvironment
}: StickerTextProps) {
  if (isDg2Project && (noProductionPlan || noProductionDomain)) {
    return "settings.domains.sticker.is_dg2";
  }
  if (noProductionPlan) {
    return "settings.domains.sticker.no_production_plan";
  }
  if (noProductionDomain) {
    return "settings.domains.sticker.no_production_domain";
  }
  return isProductionEnvironment
    ? "settings.domains.sticker.no_permissions_prod_domain"
    : "settings.domains.sticker.no_permissions";
}

export function determineUserState(
  environment,
  isDevelopment,
  domains,
  capabilityCustomDomains,
  userHasPermissions
) {
  const isProductionEnvironment = environment?.type === "production";
  let currentUser = "";

  if (!capabilityCustomDomains && !isProductionEnvironment) {
    currentUser = userType.NO_CAPABILITY;
  } else if (isDevelopment) {
    currentUser = userType.NO_PRODUCTION_PLAN;
  } else if (domains?.length === 0) {
    currentUser = userType.NO_PRODUCTION_DOMAIN;
  } else if (userHasPermissions) {
    currentUser = userType.HAS_CUSTOM_DOMAINS;
  } else {
    currentUser = userType.NO_PERMISSION;
  }

  const hasCustomDomainsOrProUser =
    currentUser === userType.HAS_CUSTOM_DOMAINS ||
    currentUser === userType.NO_CAPABILITY ||
    isProductionEnvironment;

  const hasCustomDomains = currentUser === userType.HAS_CUSTOM_DOMAINS;
  const noProductionPlan = currentUser === userType.NO_PRODUCTION_PLAN;
  const noProductionDomain = currentUser === userType.NO_PRODUCTION_DOMAIN;

  const hasDomainsProdEnvNoProdPlan =
    hasCustomDomains || (isProductionEnvironment && !noProductionPlan);

  return {
    currentUser,
    isProductionEnvironment,
    hasCustomDomainsOrProUser,
    hasCustomDomains,
    noProductionPlan,
    noProductionDomain,
    hasDomainsProdEnvNoProdPlan
  };
}
